import React, { useEffect, useState } from "react";
import { Box, Button, FormControl, Grid, IconButton, InputLabel, Select, Typography } from "@mui/material";
import { Search as IconSearch, IndeterminateCheckBox as IconIndeterminateCheckBox, CheckBox as IconCheckBox, AddBusiness as IconAddBusiness } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";
import DialogYesNo from "../../components/common/DialogYesNo";
import * as descuentoCatalogoService from "../../services/descuentoCatalogoService";
import * as catalogoService from "../../services/catalogoService";

const Index = () => {
const { isReadOnly } = useMantenimiento("descuento");
    const navigate = useNavigate();
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const [listEstados, setListEstados] = useState([]);
    const [listTipos, setListTipos] = useState([]);
    const [idEstado, setIdEstado] = useState(0);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectId, setSelectId] = useState(0);
    const [selectState, setSelectState] = useState("A");

    useEffect(() => {
        (async () => {
            setLoading(true);
            const data = await descuentoCatalogoService.getsDescuentoCatalogo().catch(() => []);
            setResults(data || []);
            setLoading(false);
        })();
        (async () => {
            const data = await catalogoService.getCatalogosByPadre(1).catch(() => []);
            setListEstados(data || []);
        })();
        (async () => {
            // 315 = Tipos de Descuento: para mostrar el nombre del tipo y no el id.
            const data = await catalogoService.getCatalogosByPadre(315).catch(() => []);
            setListTipos(data || []);
        })();
    }, []);

    const fetchResults = async (estado) => {
        setLoading(true);
        const data = await descuentoCatalogoService.getsDescuentoCatalogo().catch(() => []);
        const lista = (data || []).filter((r) => !estado || r.idEstado == estado);
        setResults(lista);
        setLoading(false);
    };

    const anularOActivar = async () => {
        if (selectState === "A") {
            await descuentoCatalogoService.annulDescuentoCatalogo(selectId).catch(() => {});
        } else {
            await descuentoCatalogoService.activeDescuentoCatalogo(selectId).catch(() => {});
        }
        setOpenDialog(false);
        fetchResults(idEstado);
    };

    const columns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'codigo', headerName: 'Codigo', width: 120, sortable: false, headerAlign: 'center', renderCell: (c) => <Link to={'/descuentocatalogo/edit/' + c.row.id} style={{ color: 'inherit' }}>{c.row.codigo}</Link> },
        { field: 'descripcion', headerName: 'Descripcion', width: 260, sortable: false, headerAlign: 'left' },
        { field: 'idTipoDescuento', headerName: 'Tipo', width: 120, sortable: false, headerAlign: 'center', align: 'center', renderCell: (c) => (listTipos.find((t) => t.id == c.row.idTipoDescuento)?.descripcion || c.row.idTipoDescuento) },
        { field: 'valor', headerName: 'Valor', width: 90, sortable: false, headerAlign: 'right', align: 'right', valueFormatter: (v) => (parseFloat(v) || 0).toFixed(2) },
        { field: 'idEstado', headerName: 'Estado', width: 90, sortable: false, headerAlign: 'center', align: 'center', renderCell: (c) => (c.row.idEstado === 2 ? 'Activo' : 'Inactivo') },
        { field: 'anular', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center', renderCell: (c) => (
            <IconButton size="small" onClick={() => { setSelectId(c.row.id); setSelectState(c.row.idEstado === 2 ? 'A' : 'I'); setOpenDialog(true); }}>
                {c.row.idEstado === 2 ? <IconIndeterminateCheckBox /> : <IconCheckBox />}
            </IconButton>
        )},
    ];

    return (
        <Box>
            <Grid container>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Descuentos Catalogo</Typography>
                <Grid container spacing={1} padding="12px 0px">
                    <Grid item xs={6} sm={3}>
                        <FormControl fullWidth>
                            <InputLabel shrink>Estado</InputLabel>
                            <Select native value={idEstado} onChange={(e) => { const v = parseInt(e.target.value); setIdEstado(v); fetchResults(v); }} size="small">
                                <option value={0}>(Todos)</option>
                                {(listEstados || []).map((e) => <option key={e.id} value={e.id}>{e.descripcion}</option>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={2} display="flex" alignItems="center">
                        <Button variant="outlined" fullWidth onClick={() => fetchResults(idEstado)}><IconSearch /></Button>
                    </Grid>
                    <Grid item xs={12}>
                        <DataGridBase rows={results} columns={columns} loading={loading} toolbarButtons={[{ text: "Nuevo", icon: <IconAddBusiness />, onClick: () => navigate("/descuentocatalogo/edit/0") }]} />
                    </Grid>
                </Grid>
            </Grid>
            <DialogYesNo open={openDialog} openClose={() => setOpenDialog(false)} setYes={anularOActivar} setNo={() => setOpenDialog(false)} titulo={selectState === 'A' ? 'Anular' : 'Activar'} texto={selectState === 'A' ? 'Anular el registro?' : 'Activar el registro?'} />
        </Box>
    );
};

export default Index;